/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetMoneyInTransDetailsInput
 */
export interface GetMoneyInTransDetailsInput {
    /**
     * Money-In ID
     * @type {number}
     * @memberof GetMoneyInTransDetailsInput
     */
    transactionId?: number;
    /**
     * Money-In Comment
     * @type {string}
     * @memberof GetMoneyInTransDetailsInput
     */
    transactionComment?: string;
    /**
     * Token from wkToken variable
     * @type {string}
     * @memberof GetMoneyInTransDetailsInput
     */
    transactionMerchantToken?: string;
    /**
     * UTC Unix timestamp, in order to return transactions initialized after it
     * @type {string}
     * @memberof GetMoneyInTransDetailsInput
     */
    startDate?: string;
    /**
     * UTC Unix timestamp, in order to return transactions initialized before it
     * @type {string}
     * @memberof GetMoneyInTransDetailsInput
     */
    endDate?: string;
}

/**
 * Check if a given object implements the GetMoneyInTransDetailsInput interface.
 */
export function instanceOfGetMoneyInTransDetailsInput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetMoneyInTransDetailsInputFromJSON(json: any): GetMoneyInTransDetailsInput {
    return GetMoneyInTransDetailsInputFromJSONTyped(json, false);
}

export function GetMoneyInTransDetailsInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMoneyInTransDetailsInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactionId': !exists(json, 'transactionId') ? undefined : json['transactionId'],
        'transactionComment': !exists(json, 'transactionComment') ? undefined : json['transactionComment'],
        'transactionMerchantToken': !exists(json, 'TransactionMerchantToken') ? undefined : json['TransactionMerchantToken'],
        'startDate': !exists(json, 'startDate') ? undefined : json['startDate'],
        'endDate': !exists(json, 'endDate') ? undefined : json['endDate'],
    };
}

export function GetMoneyInTransDetailsInputToJSON(value?: GetMoneyInTransDetailsInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transactionId': value.transactionId,
        'transactionComment': value.transactionComment,
        'TransactionMerchantToken': value.transactionMerchantToken,
        'startDate': value.startDate,
        'endDate': value.endDate,
    };
}

